var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"swiper",class:[{'dragging': _vm.dragging}],on:{"touchstart":_vm._onTouchStart,"mousedown":_vm._onTouchStart,"wheel":_vm._onWheel}},[_c('div',{ref:"infinitySwipeWrapper",staticClass:"infinity-swipe-wrapper",style:(_vm.styleObject),on:{"transitionend":_vm._onTransitionEnd}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }